import { render, staticRenderFns } from "./TeacherLateRecordsList.vue?vue&type=template&id=5fd81b6a&scoped=true"
import script from "./TeacherLateRecordsList.vue?vue&type=script&lang=js"
export * from "./TeacherLateRecordsList.vue?vue&type=script&lang=js"
import style0 from "./TeacherLateRecordsList.vue?vue&type=style&index=0&id=5fd81b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd81b6a",
  null
  
)

export default component.exports